<script>
import { format, subDays, addDays, isEqual, isSameMonth, startOfMonth, endOfMonth } from 'date-fns';

export default {
	props: {
		default_label: {
			type: String,
			required: false
		},
		mainButtonLabel: {
			type: String,
			required: false,
			default: 'Potrdi'
		},
		compact: {
			type: Boolean,
			required: false,
			default: true
		},
		noFutureValues: {
			type: Boolean,
			required: false,
			default: false
		},
		minDate: {
			type: String,
			default: null,
			required: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},
	methods: {
		click_submit: function () {
			this.$emit('input', this.selectedDate);
			this.clear();
			this.$refs.dropdown.hide();
		},
		clear: function () {
			this.is_smalltext_class = false;
			this.custom_set = false;
			this.title = null;
			this.selectedDate = null;
		}
	},
	computed: {
		selectedTitle () {
			if (this.title) {
				return this.title;
			} else if (this.default_label) {
				return this.default_label;
			} else {
				return this.default_label_empty;
			}
		},
		showCompact () {
			if (this.compact != null) {
				return this.compact;
			} else {
				return true;
			}
		}
	},
	data: function () {
		return {
			is_smalltext_class: false,
			custom_set: false,
			title: null,
			selectedDate: null,
			default_label_empty: 'Vse'
		}
	},
	created () {
	}
}
</script>
<template>
	<div class="noarrow">
		<b-dropdown :disabled="disabled" no-caret variant="primary" :text="selectedTitle" ref="dropdown" :class="{ smalldt: (is_smalltext_class && showCompact) }">
			<b-dropdown-form>
				<b-row>
					<b-col class="ml-2 mr-2" aligin-self="end" >
						<v-date-picker
							v-model="selectedDate"
							is-inline 
							:max-date="noFutureValues ? new Date() : null"
							:min-date="minDate"
							is-expanded
							locale="sl-SI"/>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="ml-2 mr-2 ma_pos" aligin-self="end">
						<b-button variant="primary" class="mt-2" size="sm" @click.prevent="click_submit">{{ mainButtonLabel }}</b-button>
					</b-col>
				</b-row>
			</b-dropdown-form>
		</b-dropdown>
	</div>
</template>
<style scoped>
.smalldt button.btn {
	font-size: 0.6rem;
}
.ma_pos {
	text-align: end;
}
</style>
<style>
.noarrow .dropdown-toggle::after {
    display:none;
}
</style>